import { AdapterApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { Adapter } from './types';

export const normalizeAdapters = (data: AdapterApi[]): Adapter[] =>
  data.map((d) => normalizeAdapter(d));

export const normalizeAdapter = (row: AdapterApi): Adapter => {
  return { ...row, uuid: uuidv4() };
};
